export default __webpack_public_path__ + "img/d0d6a3f5ee4618b6fad7ba868fb12d59.png";